import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './Login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { environment } from './environments/environment';
import { AppModule } from './app.module';

// 'login-dev' route is not available in a production environment
const devRoutes: Routes = environment.production ? [] : [
    { path: 'login-dev', component: LoginComponent, canActivate: [AuthGuard] }
];

const appRoutes: Routes = [
    { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: '**', redirectTo: 'home', pathMatch: 'full' }
];

export const appRoutingProviders: any[] = [
];

export const routing: ModuleWithProviders<AppModule> = RouterModule.forRoot([
    ...devRoutes,
    ...appRoutes 
  ]);